<template>
    <b-overlay :show="showoverlaymodal" rounded="sm" class="pf_loan_form_front row">
        <div  class="col-md-12">
            <b-form @submit.stop.prevent="onSubmit">
                {{checkName}}
                <div class="row col-12 no-margin px-0">
                    
                    <div class="ibox col-md-12 ibox col-md-12 border-0">
                        <div class="ibox-title dashboard_title">
                            <h4 class="clearfix">
                                <span class="float-left">Advance Details</span>
                                <span class="float-right"></span>
                            </h4>
                        </div>
                        <div class="ibox-content pb-0">
                            <div class="clearfix loan_card_wrapper rounded px-0 col-md-12 py-0">
                                <div class="row" v-if="approver_settings.show == 1">
                                    <div class="col-sm-6 mt-1 mb-1" >
                                        <b-form-group id="loan_id-group" label="Advance ID" label-for="loan_id">
                                            <b-form-input id="loan_id"  name="loan_id" v-model="fdata.company_loan_id"  aria-describedby="loan_amount-feedback" data-vv-as="Advance Amount"></b-form-input>
                                        </b-form-group>  
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 mt-1 mb-1">
                                        <b-form-group id="loan_amount-group" label="Advance Amount" label-for="loan_amount">
                                            <b-form-input id="loan_amount"  name="loan_amount" :disabled="disableamount" v-model="fdata.loan_amount" v-validate="{ required: true }" :state="validateState('loan_amount')" aria-describedby="loan_amount-feedback" data-vv-as="Advance Amount"></b-form-input>
                                            <b-form-invalid-feedback id="loan_amount-feedback">{{ veeErrors.first('loan_amount') }}</b-form-invalid-feedback>
                                            
                                            <template v-if="pf_loan_form_disable == true">
                                                <div class="invalid-feedback" style="display:block !important;">{{ loan_amount_disable_text }}</div>
                                            </template>
                                            <template v-if="disable_submit_amount == true">
                                                <div style="min-height:30px;">
                                                    <div v-show="disable_submit_amount==true" class="mb-1"  style="font-size: 80% !important; color: #e3342f !important" id="submit-disable">Advance amount is invalid</div>
                                                </div>
                                            </template>
                                            
                                        </b-form-group>  
                                        <template v-if="fdata_paid_amount > 0">
                                            <b-form-group id="paid_amount-group" label="Amount Paid" label-for="paid_amount" v-show="edit_form==1 && disableamount == true">
                                                <b-form-input id="paid_amount"  name="paid_amount" :disabled="disableme" v-model="fdata.paid_amount" ></b-form-input>
                                            </b-form-group>
                                        </template>
                                    </div>
                                    
                                    <div class="col-sm-6 mt-1 mb-1">
                                        <b-form-group id="effective_date_of_loan-group" label="Disbursement Date" label-for="effective_date_of_loan">
                                            <b-input-group class="mb-3" >
                                                <b-input-group-append style="width: 100%;">
                                                    
                                                    <b-form-input id="effective_date_of_loan_text"  :disabled="disableme" name="effective_date_of_loan_text" v-model="fdata.effective_date_of_loan" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('effective_date_of_loan_text')" aria-describedby="effective_date_of_loan_text-feedback" data-vv-as="Effective Date of Advance"></b-form-input>
                                                    <b-form-datepicker id="day_one" @input="getAvailableMonths(fdata.effective_date_of_loan)" button-only right locale="en-US" :min="date_min" :disabled="disableme"   v-model="fdata.effective_date_of_loan"></b-form-datepicker>
                                                </b-input-group-append>
                                                <b-form-invalid-feedback id="effective_date_of_loan_text-feedback">{{ veeErrors.first('effective_date_of_loan_text') }}</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>

                                        <template v-if="fdata_paid_amount > 0">
                                            <b-form-group id="remaining_amount-group" label="Amount Reamining" label-for="remaining_amount" v-show="edit_form==1 && disableamount == true">
                                                <b-form-input id="remaining_amount"  name="remaining_amount" :disabled="disableme" v-model="fdata.remaining_amount" ></b-form-input>
                                            </b-form-group>
                                        </template>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 mt-1 mb-1">
                                        <template v-if="fdata.status != 2 && fdata.status != 3 && fdata_paid_amount == 0">
                                            <b-form-group id="deduction_start_month-group" label="Deduction Start Month" label-for="deduction_start_month">
                                                <b-form-select id="deduction_start_month"   name="deduction_start_month" :disabled="disableamount"  v-model="fdata.deduction_start_month" :options="m_lists" v-validate="{ required: true }" :state="validateState('deduction_start_month')" aria-describedby="deduction_start_month-feedback" data-vv-as="Advance Deduction Start Month"></b-form-select>
                                                <b-form-invalid-feedback id="deduction_start_month-feedback">{{ veeErrors.first('deduction_start_month') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </template>
                                    </div>
                                    <div class="col-sm-6 mt-1 mb-1">
                                        
                                        <template v-if="missed_first_payment == false && fdata_paid_amount > 0">
                                            <template v-if="fdata.status == '3' || fdata.status == 3 || is_status == 3">
                                                <b-form-group id="change-next-deduction-month-group" >
                                                <b-form-checkbox id="checkbox-2" v-model="change_next_deduction_month" name="change_next_deduction_month" value=1 unchecked-value=0 >
                                                Change Next Deduction Month
                                                </b-form-checkbox>  
                                                </b-form-group>  
                                            </template>
                                            <template v-if="fdata.status == '2' || fdata.status == 2 || fdata.status == '3' || fdata.status == 3">
                                                <b-form-group id="next_installment_month-group"  v-bind:label="deduction_start_month_title" label-for="next_installment_month" v-show="edit_form==1">
                                                    <b-form-select id="next_installment_month" @change="changeDateAndTenure()"  :disabled="disableamount == true && change_next_deduction_month == 0"  name="next_installment_month" v-model="fdata.next_installment_month" :options="m_list_2" v-validate="{ required: true }" :state="validateState('next_installment_month')" aria-describedby="next_installment_month-feedback" data-vv-as="Advance Deduction Start Month"></b-form-select>
                                                    <b-form-invalid-feedback id="next_installment_month-feedback">{{ veeErrors.first('next_installment_month') }}</b-form-invalid-feedback>
                                                </b-form-group>
                                            </template>
                                        </template>
                                        <template v-if="edit_form==1 && disableamount == true">
                                            <b-form-group id="loan_tenure-group" label="Advance Repayment Tenure" label-for="loan_tenure">
                                                <b-form-input id="loan_tenure"  name="loan_tenure" :disabled="disableamount" v-model="loan_tenure_label" ></b-form-input>
                                            </b-form-group>
                                        </template>
                                        <template v-else>
                                            <b-form-group id="loan_tenure-group" label="Advance Repayment Tenure" label-for="loan_tenure" >
                                                <select name="Advance repayment tenure" class='form-control' v-model="fdata.loan_tenure" :disabled="disableamount" v-validate="{ required: true }" :state="validateState('loan_tenure')" aria-describedby="loan_tenure-feedback" data-vv-as="Advance repayment tenure">
                                                    <option v-for='index in tenure_list' :value='index'>
                                                        {{index }} Month(s)
                                                    </option>
                                                </select>
                                                <b-form-invalid-feedback id="loan_tenure-feedback">{{ veeErrors.first('loan_tenure') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </template>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12 mt-1 mb-1"> 
                                        <template v-if="loan_installments.length > 0"> 
                                            <a href="javascript:void(0);" class="btn mb-2 btn-primary d-inline-block px-4"   @click="showInstallments()" >Installments</a>
                                        </template>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 mt-1 mb-1">
                                        <template v-if="show_extra_installment_info==true"> 
                                                <div class="col-sm-12 mt-1 mb-1 px-0" v-if="pf_settings.pf_extra_installment.opt_value > 0" style="color: #3A52A6; font-size: 12px;">                   
                                                    <span style="font-size: 14px; color: #34444C; font-weight: 400;">Info :</span> As per Company Regulation {{ pf_settings.pf_extra_installment.opt_value }} extra installment has to be paid as service charge.
                                                </div>
                                                <!-- <div class="col-sm-12 mt-1 mb-1 px-0" style="color: #3A52A6; font-size: 12px;">                  
                                                    Total payable service charge is {{ extra_amount }} Tk.</br>
                                                    Total payable with service charge is {{ amount_with_interest }} Tk. 
                                                </div> -->
                                                
                                        </template>
                                    </div>
                                    <div class="col-sm-4 mt-1 mb-1 align-items-end justify-content-end d-none">
                                        <template> 
                                            <a href="javascript:void(0);"    style="background: transparent !important;" class="btn mb-3 mt-4 btn-primary p-0 border-0"    @click="showComments()" ><img :src="this.$api_url+'/images/Component-thread.png'"  class="" /></a>
                                        </template>
                                    </div>
                                </div> 
                            

                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-sm-12 mt-1 mb-1 text-center"> 
                        <b-button class = "mt-1" style="width:200px;" type="submit" :disabled="disable_submit_all" variant="primary">Submit</b-button>
                    </div> 
                </div>
                
                
                <b-modal id="bv-modal-installment" size="lg" hide-footer title="Installment">
     
                    <div class="row">
                        <div class="col-sm-12 mt-1 mb-1">
                                
                            <b-form-input  class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:48%;display:none !important;' v-model="checkInstallmentamount" name="ins"></b-form-input>
                            <b-form-input  class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:48%;display:none !important;' v-model="onInstallmentChange" name="onInstallmentChange"></b-form-input>
                            <b-form-input  class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:48%;display:none !important;' v-model="checkInput" name="onInstallmentChange"></b-form-input>
                            
                        
                        </div>
                    </div> 

                    <div class="row no-margin">
                        <template v-show="show_installment_click==true"> 
                            
                            <table class="employee-list-table dataTable table-overflow table-sticky" v-if="loan_installments.length > 0 && toMoney(manual_installment_amount) == 0" >
                                
                                <thead>
                                    <tr class="table-head ">
                                        <td class="">
                                            Installment No.
                                        </td>
                                        <td class="">
                                            Month
                                        </td>
                                        <td class="text-center">
                                            Amount
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="table-row"  v-for="(row, index) in loan_installments" :key="index">
                                        <td class=" cursor-pointer text-left">
                                                Installment No #{{ showInstallmentLabel(index,loan_installments[index].month) }}
                                        </td>
                                        <td class=" cursor-pointer text-left">
                                            {{ loan_installments[index].month }}
                                        </td>
                                        <td class="text-right" >
                                            {{ loan_installments[index].amount }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table class="employee-list-table dataTable table-overflow table-sticky" v-if=" toMoney(manual_installment_amount) > 0" >
                                
                                <thead>
                                    <tr class="table-head ">
                                        <td class="">
                                            Installment No.
                                        </td>
                                        <td class="">
                                            Month
                                        </td>
                                        <td class="text-center">
                                            Amount
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="table-row"  v-for="(row, index) in loan_installment_custom" :key="index">
                                        <td class=" cursor-pointer text-left">
                                                Installment No #{{ showInstallmentLabel(index,loan_installment_custom[index].month) }}
                                        </td>
                                        <td class=" cursor-pointer text-left">
                                            {{ loan_installment_custom[index].month }}
                                        </td>
                                        <td class="text-right" >
                                            {{ loan_installment_custom[index].amount }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            
                        </template>
                    </div>
                </b-modal>
                
        
            </b-form>
        </div>
       
       {{ checkPFLimit }}
   
    </b-overlay>

</template>

<script>
import { first } from 'lodash';


   export default{
      
       mounted() {
                        
       },
       props: ['pageurl','bn','flg','employee_id','employee_name','count','loan_id','is_custom','is_status','is_approver'],
       data(){  
           const now = new Date()
           const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
           const minDate = new Date(today);

           return {  
               loan_approval_status:null,
               approval_comment:'',
               thread_key:0,
               discussion_thread_title:'',
               flg_key:0,
               date_min:minDate,
               pf_contribution :0,
               total_pf_balance:0,
               total_eligible_balance:0,
               existing_loan_balance:0,
               remaining_installment_amount:0,
               atl_company_package_title: this.$atl_company_package_title,
               remaining_amount_money : 0,
               loan_installments:[],
               loan_type: 1,
               loan_type_select: 1,
               edit_form : 0,
               showoverlaymodal : true,  
               pf_loan_form_disable : false,  
               no_installment : true,
               edit_change_click :false,
               show_installment_click : false,
               disable_submit :false,
               disable_submit_all :false,
               disable_submit_amount :false,
               showInstallment : false,
               disableme: false,
               disableamount : false,  
               pf_settings:[],
               m_lists:[],
               m_list_2:[],
               pf_loan_terms:[],
               default_tenure:12, 
               tenure_list:[],
               fdata : {company_loan_id:'', employee_id:'',installments:[], loan_amount:'',loan_type:'',effective_date_of_loan:null ,deduction_start_month:null , core_hr:'' , loan_tenure:'',details:'',status:1,next_installment_month:'',paid_amount:'',change_deduction:"No",change_tenure:"No",loan_reason:'',paid_tenure:0,remaining_tenure:0,remaining_amount:'',custom_amount:0,core_hr:null},
               loan_status:[
                   { value: null, text: "Select..." },
                   { value: "0", text: "Decline" },
                   { value: "1", text: "Applied" },
                   { value: "2", text: "Approve" },
                   { value: "3", text: "Pause/Stop" },
               ],
               approval_status:[
                   { value: "1", text: "Approve / Forward" },
                   { value: "2", text: "Defer" },
                   { value: "3", text: "Reject" },
               ],
               loan_type_vals:[
                   { value: "1", text: "Loan" },
                   { value: "2", text: "Advance" },
               ],

               rejection_reason:['Not Eligible for loan','Insufficient Documents','Company is not processing loan'],
               ln_stat:["Applied","Approved","Defered","Rejected"],
               show_extra_installment_info:false,
               extra_installment_info:'',
               amount_with_interest:0,
               extra_amount:0,
               company_id:0,
               approver_settings:[],
               loan_approver_app_id : 0,
               bdata: {employee_id: this.employee_id, beneficiary_name:this.employee_name, bank_name:null},
               bank_names: [
                    { value: null, text: "--Select--" },
                ],   
                bank_key:0,

                bank_data_new:[],
                deduction_start_month_title:'',
                loan_amount_disable_text:"The Advance Amount must be less or equal to the total provident fund balance",
                upload_file:[],
                loan_tenure_label:'',
                old_repayment_tenure:0,
                old_loan_amount:0,
                show_bank_details:0,
                change_next_deduction_month:0,
                missed_first_payment:false,
                fdata_paid_amount:0,
                manual_installment_number:null,
                manual_installment_options:[],
                manual_installment_amount:0,
                loan_installment_custom:[],
    
           }
       },
       methods:
       {
           validateState(ref)
           {
               if ( this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated) )
               {

                   return !this.veeErrors.has(ref);
               }
               return null;
           },
           manualPaymentList(remaining_tenure,interest_tenure) 
            {
                var  total_months = remaining_tenure + interest_tenure;
                for (let i = 0; i <= total_months;i++)
                {
                    if(i==0)
                    {
                        this.manual_installment_options.push({text: 'Select installment...',value:null});
                        continue;
                    }

                    this.manual_installment_options.push({text: i+' Month(s)',value:i});
                    
                }
            },
            manualPaymentCalculate()
           {
                var total_installment_length = this.loan_installments.length;
                var manual_payment_amount = 0;
                var all_installments =  this.loan_installments;
                this.loan_installment_custom = [];
                var manual_installment_number = this.manual_installment_number;
                var  temp_amount = 0.00;
                var ct = 0;
                console.log(this.loan_installment_custom);  
                for (var i=0; i < manual_installment_number; i++ )
                {   
                    temp_amount = this.toMoney(this.loan_installments[i].amount);
                    temp_amount = Math.round(  temp_amount * 100) / 100;
                    manual_payment_amount += temp_amount;
                }

                this.manual_installment_amount = this.formatMoney(manual_payment_amount);

                for (var i= manual_installment_number; i < total_installment_length; i++ )
                {
                    ct = i - manual_installment_number;
                   
                    this.loan_installment_custom.push({month: this.loan_installments[ct].month,amount:this.loan_installments[i].amount});
                    // this.loan_installment_custom[i- manual_installment_number].month = this.loan_installments[i- manual_installment_number].month
                    // this.loan_installment_custom[i - manual_installment_number].amount = this.loan_installments[i].amount
                }

           },
           fieldChange(e) {
         

                let selectedFiles = e.target.files;
                this.upload_file = [];
                if (!selectedFiles.length) {
                    return false;
                }

                for (let i = 0; i < selectedFiles.length; i++) {
                    this.upload_file.push(selectedFiles[i]);
                }
            },
            formatNames(files) {
                return files.length === 1 ? files[0].name : `${files.length} files selected`;
            },
           resetFormBank()
            {
                this.bdata = {
                    employee_id: this.employee_id,
                    beneficiary_name: this.employee_name,
                    account_no: null,
                    bank_name: null,
                    routing_number:null,
                    branch_name:null,
                    swift_code:null,
                    type:1,
                    loan_id: this.fdata.id,
                };

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            setFormBank(data)
            {
               
                if(data.id > 0)
                {
                        this.bdata = {
                        id: data.id,
                        employee_id: data.employee_id,
                        beneficiary_name: data.beneficiary_name,
                        account_no: data.account_no,
                        bank_name: data.bank_name,
                        type:data.type,
                        loan_id: data.loan_id,
                    };

                
                    this.bdata.routing_number='';
                    this.bdata.branch_name='';
                    this.bdata.swift_code='';

                    if(data.routing_number != null && data.routing_number != 'null')
                    {
                        this.bdata.routing_number= data.routing_number;
                    }
                    if(data.branch_name != null && data.routing_number != 'null')
                    {
                        this.bdata.branch_name= data.branch_name;
                    }
                    if(data.swift_code != null && data.routing_number != 'null')
                    {
                        this.bdata.swift_code= data.swift_code;
                    }
                    
                }
                else
                {
                    this.bdata = {
                    employee_id: this.employee_id,
                    beneficiary_name: this.employee_name,
                    account_no: null,
                    bank_name: null,
                    routing_number:null,
                    branch_name:null,
                    swift_code:null,
                    type:1,
                    loan_id: this.loan_id, 
                    };
                }
                this.bank_key += 1;




            },
            editBankInfoNew:function(x)
            {        
                this.resetFormBank();
        
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/pf/loan/bank-info' , {
                    params: {
                        loan_id: x,
                        type: 1
                    }
                }).then(function(response){
                    let d = response.data;

                    this.setFormBank(d);
                    
                    //this.bdata = response.data;
                    this.successmsg = null;
                
                }.bind(this)).catch(function (error){console.log(error)});               
                
            },
            editBankInfo:function(x)
            {        
                // this.resetFormBank();
        
                // if(!this.checkNet()) return false;
                // let currentObj = this;
                // axios.get(this.$api_url+'/pf/loan/bank-info' , {
                //     params: {
                //         loan_id: x,
                //         type: 1
                //     }
                // }).then(function(response){
                //     let d = response.data;

                //     this.setFormBank(d);
                    
                //     //this.bdata = response.data;
                //     this.successmsg = null;
                    
                // }.bind(this)).catch(function (error){console.log(error)});  
                
                
                this.$bvModal.show('bv-modal-bank');
                
            },   
           showInstallments()
           {
               this.$bvModal.show('bv-modal-installment');
           },
           addNewLoan:function(x)
           {
               
               //alert("hegeegeefefef");
               this.resetForm();
               this.loan_status = [{ value: null, text: "Select..." },{ value: "1", text: "Applied" },{ value: "2", text: "Approve" }];
           },
           showInstallmentLabel(index,month)
           {
               var indexs = parseInt(index) +1 ;

               //var label = 'Installment # '+index+' on '+month;

               return indexs;
           },
           resetForm()
           {    
               this.pf_contribution = 0;
               this.amount_with_interest = 0;
               this.no_installment = true;
               this.edit_change_click = false;
               this.pf_loan_form_disable= false,  
               this.show_installment_click = false;
               this.disable_submit =false;
               this.disable_submit_all =false;
               this.disable_submit_amount =false;
               this.showInstallment = false;
               this.disableme = false;
               this.show_extra_installment_info = false; 
               this.disableamount = false,
               this.loan_installments = [];
               this.edit_form =0;
               this.fdata = {company_loan_id:'', employee_id:this.employee_id, loan_amount:'',installments:[],remaining_amount: null,next_installment_month:'',loan_type:this.loan_type, effective_date_of_loan:'' , deduction_start_month:null , loan_tenure:this.default_tenure, details:'',loan_reason:'',status:1,paid_amount:'',paid_tenure:0,remaining_tenure:0,remaining_amount:'',change_deduction:"No",change_tenure:"No",custom_amount:0,core_hr:"1"};
               this.$nextTick(() => {
                   this.$validator.reset();
               });
               this.upload_file = [];

           },  
           showAttachments()
           {
               this.$bvModal.show('show_attachments');
               this.flg_key += 1;
           },
           showComments()
           {
               this.discussion_thread_title = 'Comments';
               this.$bvModal.show('bv-modal-discussion-thread');
               this.thread_key += 1;
           },
           showApprovalHistory()
           {
               this.discussion_thread_title = 'Approval History';
               this.$bvModal.show('bv-modal-approval-history');
               this.thread_key += 1;
           },
            
           formatMoneyNew: function(amount)
           {
               var money = Number(amount);

              if(1)
               {
                   money = money.toLocaleString();
                   if(money=='NaN')
                   money = amount;
                   else{
                   if(money.indexOf(".")<0)
                   money = money+".00";
                   }

               }
           
               return money;
           },

           
           formatMoney: function(amount)
           {
               var money = Number(amount);

               if(this.$atl_company_number_format == 'no')
               {
                   money = Math.round(money);
                   money = money.toLocaleString();
               }
               else
               {
                   money = money.toLocaleString();
                   if(money=='NaN')
                   money = amount;
                   else{
                   if(money.indexOf(".")<0)
                   money = money+".00";
                   }

               }
           
               return money;
           },
           toMoney: function(amount)
           {

               
               if(amount !="0")
               {
                       if(!isNaN(amount))
                       {
                           var number = Number(amount);
                           return number;
                       }
                       
                   var NumWithoutCommas = amount.replace(/,/g, '');
                   var number = Number(NumWithoutCommas).toFixed(2);
                   return number;
               }else
                   return amount;
           },
           getAvailablePf()
           {
               let formData = new FormData();
               
               formData.append('employee_id', this.employee_id);
               formData.append('loan_application', 'yes');  
               axios.post(this.$api_url+'/pf/employee/available-amount', formData)
                   .then(function (response)
                   {    
                       this.total_pf_balance = response.data.pf_balance;
                       this.total_eligible_balance = response.data.loan_eligible_balance;
                       
                       this.getExisitingLoanBalance();
                   }.bind(this))
                   .catch(function (error)
                   {
                       console.log(error);
                   });
           },
           getExisitingLoanBalance()
           {
               let formData = new FormData();
               formData.append('employee_id', this.employee_id);
               axios.post(this.$api_url+'/pf/employee/loan-balance', formData)
                   .then(function (response)
                   {    
                       this.existing_loan_balance = response.data.loan_availed - response.data.loan_returned;

                       this.pf_contribution = this.total_eligible_balance - this.existing_loan_balance;
                       
                       this.showoverlaymodal = false; 
                       
                   }.bind(this))
                   .catch(function (error)
                   {
                       console.log(error);
                   });
           },
           tenureLabel(x)
           {
                
           },
           getPFSettings: function()
           { 
               
               let currentObj = this;
               axios.get(this.$api_url+'/pf/settings').then(function (response) {
                   currentObj.pf_settings = response.data.data;

                   
                   currentObj.default_tenure = currentObj.pf_settings.pf_loan_max_installment_limit.opt_value;
                   currentObj.tenure_list = Array.from({length: currentObj.default_tenure }, (_, i) => i + 1);
                   currentObj.fdata.loan_tenure = currentObj.pf_settings.pf_loan_max_installment_limit.opt_value;
                  
                       
               })  
               .catch(function (error) {
                console.log(error);
               });
               
           },
           getPFLoanTerms: function()
           { 
               
               let currentObj = this;
               axios.get(this.$api_url+'/company/pf-loan-terms').then(function (response) {
                   currentObj.pf_loan_terms = response.data;

                   
                  
                       
               })  
               .catch(function (error) {
                console.log(error);
               });
               
           },            
           getLastPayrun: function(id)
           {
               if(!this.checkNet()) return false;
                let formData = new FormData();
                formData.append('employee_id',id);
                axios.post(this.$api_url+'/pf/get-last-payrun', formData)
                .then(function (response)
                {
                   this.last_payrun_month = response.data;


                   var m_names = ['January', 'February', 'March',
                               'April', 'May', 'June', 'July',
                               'August', 'September', 'October', 'November', 'December'];

                   /** Get Last Payrun Date **/
                   var last_payrun_month_2 = this.last_payrun_month;
                   const str_month_arr_2 = last_payrun_month_2.split("-");
                   var payrun_year   = parseInt(str_month_arr_2[1]);
                   var p_month  = str_month_arr_2[0];
                   var payrun_month = m_names.indexOf(p_month);
                   var dt1   = 1;
                   const payrun_date = new Date(payrun_year,payrun_month,dt1);
                   payrun_date.setMonth(payrun_date.getMonth()+1);

                   this.date_min = payrun_date;


                   /****/
               }.bind(this));
           },
           
           getInstallments()
           {
               var m_names = ['January', 'February', 'March',
                       'April', 'May', 'June', 'July',
                       'August', 'September', 'October', 'November', 'December'];
               var all_months = [];
               var all_amounts = [];
               var installments = [];
               var generate = 0;
               var pf_loan_installment_type = this.pf_settings.pf_loan_installment.opt_value;
               var pf_extra_installment = this.pf_settings.pf_extra_installment.opt_value;
               var pf_interest_rate = parseFloat(this.pf_settings.pf_interest_rate.opt_value);

               var loan_tenure = parseInt(this.fdata.loan_tenure);

               var loan_amount = this.toMoney(this.fdata.loan_amount);
                
                if(!this.edit_form)
                {

                    var pattern = /^(0|[1-9][0-9]{0,2}(?:(,[0-9]{3})*|[0-9]*))(\.[0-9]+){0,1}$/;
                    //if(pattern.test(this.fdata.loan_amount))
                    
                    var loan_tenure = parseInt(this.fdata.loan_tenure);
                    var old_loan_tenure = parseInt(this.fdata.loan_tenure);

                    if(pf_loan_installment_type == 'plus_one')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'plus_one_fixed')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'govt_interest')
                    {
                        if(loan_tenure <= 12)
                        {
                            loan_tenure +=1;
                            pf_extra_installment = 1;
                        }
                        else
                        {
                            loan_tenure +=2;
                            pf_extra_installment = 2;
                        }

                    }

                    var start_month = this.fdata.deduction_start_month;
                    

                    if(loan_amount==0)
                    {
                        this.disable_submit_amount =true;
                        generate =0;
                    }
                    else
                    {
                        this.disable_submit_amount =false;
                        loan_amount = Math.round(loan_amount * 100) / 100;
                        generate =1;
                    }
                }

                else if(this.old_repayment_tenure != 0 && (this.old_repayment_tenure!= (this.fdata.loan_tenure + this.fdata.interest_tenure)))
                {
                    
                    this.old_repayment_tenure = this.fdata.loan_tenure + this.fdata.interest_tenure;
                    var start_month = this.fdata.deduction_start_month;
                    var old_loan_tenure = parseInt(this.fdata.loan_tenure);

                    if(pf_loan_installment_type == 'plus_one')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'plus_one_fixed')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'govt_interest')
                    {
                        if(loan_tenure <= 12)
                        {
                            loan_tenure +=1;
                            pf_extra_installment = 1;
                        }
                        else
                        {
                            loan_tenure +=2;
                            pf_extra_installment = 2;
                        }

                    }

                    generate =1;
                }

                else if(this.old_loan_amount != 0 && (this.old_loan_amount !=  loan_amount))
                {
                    
                    this.old_loan_amount = loan_amount;
                    var start_month = this.fdata.deduction_start_month;
                    var old_loan_tenure = parseInt(this.fdata.loan_tenure);

                    if(pf_loan_installment_type == 'plus_one')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'plus_one_fixed')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'govt_interest')
                    {
                        if(loan_tenure <= 12)
                        {
                            loan_tenure +=1;
                            pf_extra_installment = 1;
                        }
                        else
                        {
                            loan_tenure +=2;
                            pf_extra_installment = 2;
                        }

                    }

                    generate =1;
                }
                else if((this.fdata.status == 2 || this.fdata.status == 3 || this.fdata.status == 7) && this.fdata_paid_amount == 0) 
                {
                    var remaining_amount  =  this.toMoney(this.fdata.remaining_amount);
                    loan_amount = remaining_amount;
                    var old_loan_tenure = parseInt(this.fdata.remaining_tenure);
                    var loan_tenure = parseInt(this.fdata.remaining_tenure);
                    // if(this.fdata.next_installment_month == null)
                    // {
                        this.fdata.next_installment_month = this.fdata.deduction_start_month
                    // }
                    

                    if(this.fdata.status == 7)
                    {
                        var loan_tenure = parseInt(this.fdata.loan_tenure);
                        var old_loan_tenure = parseInt(this.fdata.loan_tenure);
                        var loan_amount = this.toMoney(this.fdata.loan_amount);
                        var remaining_amount  =  this.toMoney(this.fdata.loan_amount);
                    }

                    var start_month = this.fdata.next_installment_month;

                    if(pf_loan_installment_type == 'plus_one')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'plus_one_fixed')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'govt_interest')
                    {
                        if(loan_tenure <= 12)
                        {
                            loan_tenure +=1;
                            pf_extra_installment = 1;
                        }
                        else
                        {
                            loan_tenure +=2;
                            pf_extra_installment = 2;
                        }

                    }

                    generate =1;
                }
                else if(this.is_status == 3 || (this.is_status == 2 && this.fdata.status == 3)) 
                {
                    var remaining_amount  =  this.toMoney(this.fdata.remaining_amount);
                    loan_amount = remaining_amount;
                    var old_loan_tenure = parseInt(this.fdata.remaining_tenure);
                    var loan_tenure = parseInt(this.fdata.remaining_tenure);
                    if(this.fdata.next_installment_month == null)
                    {
                        this.fdata.next_installment_month = this.fdata.deduction_start_month
                    }

                    var start_month = this.fdata.next_installment_month;

                    if(pf_loan_installment_type == 'plus_one')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'plus_one_fixed')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'govt_interest')
                    {
                        if(loan_tenure <= 12)
                        {
                            loan_tenure +=1;
                            pf_extra_installment = 1;
                        }
                        else
                        {
                            loan_tenure +=2;
                            pf_extra_installment = 2;
                        }

                    }

                    generate =1;
                }


                // else if(this.edit_form && this.fdata.status == 1)
                // {
                //     var start_month = this.fdata.deduction_start_month;
                    
                //     generate =1;
                // }

               //generate =0;

    
               console.log('generate');
               console.log(generate);

               if(generate==1)
               {
                   const str_month_arr = start_month.split("-");
                   var yr1   = parseInt(str_month_arr[1]);
                   var mt  = str_month_arr[0];
                   var mon1 = m_names.indexOf(mt);
                   var dt1   = 1;
                   for (let i = 0; i < loan_tenure;i++)
                   {

                       var d = new Date(yr1, mon1, dt1);
                       d.setMonth(d.getMonth() + i);
                       var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                       all_months.push(fullText);
                   
                   }
                   
                   if(all_months.length==loan_tenure)
                   {  

                       if(pf_loan_installment_type != 'plus_one' && pf_loan_installment_type != 'plus_one_fixed' && pf_loan_installment_type != 'govt_interest' && pf_loan_installment_type != 'fixed_interest')
                       {
                           loan_amount = Math.round(loan_amount * 100) / 100;
                           var frac_month_amount = loan_amount/loan_tenure;
                           
                           for (let i = 0; i < loan_tenure;i++)
                           {
                               all_amounts.push(frac_month_amount);
                           }
                       }
                       else
                       {
                          
                           var frac_month_amount = loan_amount/old_loan_tenure;
                           frac_month_amount = Math.round(frac_month_amount  * 100) / 100;
                           
                           if(pf_loan_installment_type == 'plus_one')
                           {   

                               
                                frac_month_amount = Math.round(frac_month_amount);
                                let rounded_frac_month_amount = Math.round(frac_month_amount);
                                let total_installment_number  = old_loan_tenure + 1;
                                let rounded_payable_amount = rounded_frac_month_amount * total_installment_number;
                                let fractioned_payable_amount = rounded_payable_amount - loan_amount - frac_month_amount; 
                                let fractioned_payable_amount_pivot = fractioned_payable_amount; 

                                let pushed_amount = 0;

                                let remaining_tenure = loan_tenure;
         
                                
                               for (let i = 0; i < loan_tenure;i++)
                               {   
                                    
                                    remaining_tenure = loan_tenure - i;
                                    
                                    if(fractioned_payable_amount_pivot > 0 && (remaining_tenure == fractioned_payable_amount_pivot))
                                    {   
                                        pushed_amount = frac_month_amount - 1;
                                        all_amounts.push(pushed_amount);
                                        fractioned_payable_amount_pivot -= 1;
                                    }
                                    else if(fractioned_payable_amount_pivot < 0)
                                    {
                                        
                                        pushed_amount = frac_month_amount + 1;
                                        all_amounts.push(pushed_amount);
                                        fractioned_payable_amount_pivot += 1;
                                    }
                                    else
                                    {
                                        all_amounts.push(frac_month_amount);
                                    }

                                    
                                //    if(i==0)
                                //    {
                                //        all_amounts.push(frac_month_amount);
                                //        continue;
                                //    }  
                                   //all_amounts.push(frac_month_amount);
                               }
                           
                           }
                           else if(pf_loan_installment_type == 'plus_one_fixed')
                           {   

                               
                                var govt_interest_amount = (loan_amount/100)*pf_interest_rate;
                                
                                govt_interest_amount = govt_interest_amount/pf_extra_installment;

                                govt_interest_amount = Math.trunc(govt_interest_amount*100)/100; 

                                for (let i = 0; i < old_loan_tenure; i++)
                                {
                                    all_amounts.push(frac_month_amount); 
                                }

                                for (let i = 0; i < pf_extra_installment; i++)
                                {
                                    all_amounts.push(govt_interest_amount);
                                }
                           
                                console.log("1393");  
                                console.log(govt_interest_amount);
                           }
                           else if(pf_loan_installment_type == 'govt_interest')
                           {

                               var govt_interest_amount = (loan_amount/100)*pf_interest_rate;


                               for (let i = 0; i < old_loan_tenure; i++)
                               {
                                   all_amounts.push(frac_month_amount);
                               }

                               for (let i = 0; i < pf_extra_installment; i++)
                               {
                                   all_amounts.push(govt_interest_amount);
                               }
                               
                           }
                           else if(pf_loan_installment_type == 'fixed_interest')
                           {

                               var govt_interest_amount = (loan_amount/100)*pf_interest_rate;

                               var total_interest = (govt_interest_amount/12)*old_loan_tenure;

                               var interest_amount = ((total_interest/100)*100)/old_loan_tenure;
                               
                               interest_amount = Math.round(interest_amount  * 100) / 100;

                               var ins_amount = frac_month_amount + interest_amount;
                               ins_amount = Math.round(ins_amount  * 100) / 100;

                               for (let i = 0; i < old_loan_tenure; i++)
                               {
                                   all_amounts.push(ins_amount); 
                               }

                               
                           }
                           
                       }

                       if(all_amounts.length==loan_tenure)
                       {
                           var ct = 0;
                           for (let i = 0; i < loan_tenure;i++)
                           {
                               if(all_amounts[i]<=0)
                               {
                                   ct++;
                                   continue;
                               }

                               installments.push({month: all_months[i],amount:all_amounts[i]});
                               ct++;
                           }
                       }
                       if(loan_tenure==ct)
                       {
                           if(installments.length!=loan_tenure)
                           {
                               if(installments.length==0 && this.edit_form)
                               {
                                   this.fdata.remaining_tenure = 0;
                               }
                               else if(!this.edit_form)
                               {
                                   this.fdata.loan_tenure = installments.length;
                               }
                               else if(this.edit_form)
                               {
                                   this.fdata.remaining_tenure = installments.length;
                               }
                           }


                           if(installments.length>0)
                           {
                               for(let i = 0; i<installments.length; i++)
                               {
                                   installments[i].amount = installments[i].amount;
                               }

                           }
                           
                           this.loan_installments = installments;
                        }

                   }

                } 
                
           },
           getAvailableMonths(date)
           {
    
               if(!this.edit_form)
               {
                   var m_names = ['January', 'February', 'March', 
                               'April', 'May', 'June', 'July', 
                               'August', 'September', 'October', 'November', 'December'];

                   /** Get Last Payrun Date **/
                   var last_payrun_month_2 = this.last_payrun_month;
                   const str_month_arr_2 = last_payrun_month_2.split("-");
                   var payrun_year   = parseInt(str_month_arr_2[1]);
                   var p_month  = str_month_arr_2[0]; 
                   var payrun_month = m_names.indexOf(p_month);
                   var dt1   = 1;
                   const payrun_date = new Date(payrun_year,payrun_month,dt1);
                   payrun_date.setMonth(payrun_date.getMonth()+1);
                   /****/
                   //this.fdata.deduction_start_month = null;
                   var yr1   = parseInt(date.substring(0,4));
                   var mon1  = parseInt(date.substring(5,8)); 
                   var dt1   = parseInt(date.substring(8,10));
                   var all_months = [];
                   
                   all_months.push({value: null,text: "Select..."}); 
                   let mt =0;
                   for (let i = 1; i <= 24;) 
                   { 
                       var d = new Date(yr1, mon1-1, dt1);
                       if(d.getDate()>27)
                       {
                           d.setDate(d.getDate() - 5);
                       }
                       d.setMonth(d.getMonth() + mt);


                       if(d.getTime() >= payrun_date.getTime())
                       {
                           var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                           all_months.push({value: fullText,text:fullText});
                           i++;
                       
                       }
                       
                       mt++;
                 
                   }
                   
                   if(all_months.length>=24)
                   {
                       this.m_lists =  all_months;
                       this.deduction_start = false;
                   }
               }
               else
               {
                

                    let formData = new FormData();
                    formData.append('employee_id',this.employee_id);
                    formData.append('effective_date',date);
                    axios.post(this.$api_url+'/pf/get-last-payrun', formData)
                    .then(function (response)
                    {
                   

                       var m_names = ['January', 'February', 'March', 
                               'April', 'May', 'June', 'July', 
                               'August', 'September', 'October', 'November', 'December'];
                       /** Get Last Payrun Date **/
                       this.last_payrun_month = response.data;
                       var last_payrun_month_2 = this.last_payrun_month;
                       const str_month_arr_2 = last_payrun_month_2.split("-");
                       var payrun_year   = parseInt(str_month_arr_2[1]);
                       var p_month  = str_month_arr_2[0]; 
                       var payrun_month = m_names.indexOf(p_month);
                       var dt1   = 1;
                       var payrun_date = new Date(payrun_year,payrun_month,dt1);
                       payrun_date.setMonth(payrun_date.getMonth()+1);

                       
                       this.date_min = payrun_date;

                       var yr1   = parseInt(date.substring(0,4));
                       var mon1  = parseInt(date.substring(5,8)); 
                       var dt1   = parseInt(date.substring(8,10));
                       var all_months = [];
                       var not_avail = 1;
                       var first_full = '';


                       var selected_date = new Date(yr1, mon1-1, dt1);

                       var date_check = Date.parse(payrun_date) > Date.parse(selected_date);

    
                       
                    //    if(date_check)
                    //    {
                    //        this.fdata.effective_date_of_loan = '';
                    //        this.fdata.deduction_start_month = '';
                           
                    //    }


                       all_months.push({value: null,text: "Select..."}); 
                       let mt =0;
                       for (let i = 1; i <= 24;) 
                       { 
                           var d = new Date(yr1, mon1-1, dt1);
                           if(d.getDate()>27)
                           {
                               d.setDate(d.getDate() - 5);
                           }
                           d.setMonth(d.getMonth() + mt);

                           if(d.getTime() >= payrun_date.getTime())
                           {
                               var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();

                               if(i==3)
                               {
                                   first_full = fullText;
                                   //this.getInstallments();
                               } 

                               if(this.fdata.deduction_start_month==fullText)
                               {
                                    not_avail = 0;
                               }
                              
                               all_months.push({value: fullText,text:fullText});
                               i++;
                           
                           }
                           
                           mt++;
                       }


                    //   console.log('first_full');
                    //   console.log(first_full);
                        // this.fdata.deduction_start_month = first_full;
                       
                       
                       if(all_months.length>=24)
                       {
                           this.m_lists =  all_months;
                           this.deduction_start = false;
                       }

                   }.bind(this));
               }

           },  
            getNextAvailableMonths()
            {

                
                var paid_amount = this.toMoney(this.fdata.paid_amount);
                let formData = new FormData();
                formData.append('employee_id',this.employee_id);

                axios.post(this.$api_url+'/pf/get-last-payrun', formData)
                .then(function (response)
                {

                    this.last_payrun_month = response.data;
                    if(this.edit_form)
                    { 
                        this.deduction_start_month_title = 'Next Deduction Month'; 

                        var m_names = ['January', 'February', 'March', 
                                'April', 'May', 'June', 'July', 
                                'August', 'September', 'October', 'November', 'December'];
                        var all_months = [];
        
                        if(paid_amount==0)
                        {
                            if(paid_amount==0)
                            {
                                var date  = this.fdata.effective_date_of_loan;
                                var yr1   = parseInt(date.substring(0,4));
                                var mon1  = parseInt(date.substring(5,8)); 
                                mon1 = mon1-1;
                                var dt1   = parseInt(date.substring(8,10));
                                var d = new Date(yr1, mon1, dt1);
                                var last_payrun_month_2 = this.last_payrun_month;
                                const str_month_arr_2 = last_payrun_month_2.split("-");
                                var payrun_year   = parseInt(str_month_arr_2[1]);
                                var p_month  = str_month_arr_2[0]; 
                                var payrun_month = m_names.indexOf(p_month);
                                var dt2   = 1;
                                const payrun_date = new Date(payrun_year,payrun_month,dt2);
                                payrun_date.setMonth(payrun_date.getMonth()+1);
                                var date_check = Date.parse(payrun_date) > Date.parse(d);
                                var no_install = true;
                                var p_date = payrun_date;

                               // Ali test disable 11-5-2023

                                if(date_check)
                                {
                                   
                                    this.fdata.effective_date_of_loan = '';
                                    this.fdata.deduction_start_month = '';
                                    this.fdata.next_installment_month = null;
                                    this.m_list_2 = [];
                                    this.missed_first_payment = true;
                                    
                                }
                                else
                                {
                                    for (let i = 0; i < 24;)  
                                    { 
                                        var d = new Date(yr1, mon1, dt1);
                                        if(d.getDate()>27)
                                        {
                                            d.setDate(d.getDate() - 5);
                                        }
                                        d.setMonth(d.getMonth() + i);
                                        var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();

                                        all_months.push({value: fullText,text:fullText});
                                        i++;
                                    }
                                }


                                console.log('all_months');
                                console.log(all_months);
                        
                            }

                            if(all_months.length>=24)
                            {
                                this.m_list_2 =  all_months;
                            }
                        }
                        else
                        {


                            var last_payrun_month_2 = this.last_payrun_month;
                            const str_month_arr_2 = last_payrun_month_2.split("-");
                            var payrun_year   = parseInt(str_month_arr_2[1]);
                            var p_month  = str_month_arr_2[0]; 
                            var payrun_month = m_names.indexOf(p_month);
                            var dt2   = 1;
                            const payrun_date = new Date(payrun_year,payrun_month,dt2);
                            payrun_date.setMonth(payrun_date.getMonth()+1);
                            var start_month = this.fdata.next_installment_month;
                            const str_month_arr = start_month.split("-");
                            var yr1   = parseInt(str_month_arr[1]);
                            var mt  = str_month_arr[0]; 
                            var mon1 = m_names.indexOf(mt);
                            var dt1   = 1;
                            var current_date = new Date();
                            var d1 = new Date(yr1, mon1);
                            var d2 = new Date(current_date.getFullYear(), current_date.getMonth());    // 02/2014

                            var date_check_payrun_and_next_install = Date.parse(d2) > Date.parse(payrun_date);
                            var date_check = Date.parse(d2) > Date.parse(d1);
                            var no_install = false;
                            
                            if(this.fdata.remaining_tenure == this.fdata.loan_tenure)
                            {
                                no_install = true;
                                
                            }

                            // Ali test disable 11-5-2023
                            if(date_check==true && no_install == true)
                            {

                                this.loan_installments = [];
                                this.fdata.installments = [];
                                for (let i = 0; i < 24;)  
                                { 
                                    var d = new Date();
                                    if(d.getDate()>27)
                                    {
                                        d.setDate(d.getDate() - 5);
                                    }
                                    d.setMonth(d.getMonth() + i);
                                    var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                                    if(i==0)
                                    {
                                        this.fdata.next_installment_month = fullText;
                                        //this.getInstallments();
                                    } 
                                    all_months.push({value: fullText,text:fullText});
                                    i++;
                                }
                                
                            }

                            if(date_check_payrun_and_next_install==true)
                            {
                                for (let i = 0; i < 24;)  
                                { 
                                    var d = new Date(payrun_year,payrun_month,dt2);
                                    
                                    d.setMonth(d.getMonth() + 1);
                                    if(d.getDate()>27)
                                    {
                                        d.setDate(d.getDate() - 5);
                                    }
                                    d.setMonth(d.getMonth() + i);
                                    var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();

                                    all_months.push({value: fullText,text:fullText});
                                    i++;
                                }
                            }
                            
                            else
                            {
                                for (let i = 0; i < 24;)  
                                { 
                                    var d = new Date(yr1, mon1, dt1);
                                    if(d.getDate()>27)
                                    {
                                        d.setDate(d.getDate() - 5);
                                    }
                                    d.setMonth(d.getMonth() + i);
                                    var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();

                                    all_months.push({value: fullText,text:fullText});
                                    i++;
                                }

                            }

                            
                            
                            if(all_months.length>=24)
                            {
                                this.m_list_2 =  all_months;
                            }

                            
                        }
                    }
                }.bind(this));


               

            },
           
           editLoanInfo:function(x,type)
           {        
               
               if(!this.checkNet()) return false;

                   if(type==0)
                   {
                       this.resetForm();
                       this.is_custom_payment =0;
                   }
                   if(type==1)
                   {
                       this.resetForm();
                       this.is_custom_payment =1;
                   }


                   let currentObj = this;
                   axios.get(this.$api_url+'/pf/settings').then(function (response) {
                       currentObj.pf_settings = response.data.data;

                       
                       currentObj.default_tenure = currentObj.pf_settings.pf_loan_max_installment_limit.opt_value;
                       currentObj.tenure_list = Array.from({length: currentObj.default_tenure }, (_, i) => i + 1);
                       currentObj.fdata.loan_tenure = currentObj.pf_settings.pf_loan_max_installment_limit.opt_value;
                       
                       axios.get(currentObj.$api_url+'/pf/loan/edit' , {
                       params: {
                           id: x 
                       }
                       })
                       .then(function(response){
                           currentObj.edit_change_click = false;
                           currentObj.fdata = response.data;
                           currentObj.company_id = currentObj.fdata.company_id;
                           currentObj.thread_key += 1;
   
                           
                           /***** */
                           if(currentObj.fdata.loan_amount != currentObj.fdata.remaining_amount)
                           {
                               currentObj.loan_status = [{ value: null, text: "Select..." },{ value: "2", text: "Approve" },{ value: "3", text: "Pause/Stop" }];
                           }

                           currentObj.disableamount = true;
                           if(currentObj.fdata.status==1)
                           {
                               currentObj.loan_status =  [{ value: null, text: "Select..." },{ value: "0", text: "Decline" },{ value: "1", text: "Applied" },{ value: "2", text: "Approve" }];
                               currentObj.disableamount = false;
                           
                           }

                           if(currentObj.fdata.company_loan_id == 'N/A')
                           {
                                currentObj.fdata.company_loan_id = '';
                           }

                           currentObj.fdata.loan_amount =  currentObj.formatMoney(currentObj.fdata.loan_amount);
                           currentObj.fdata_paid_amount = currentObj.fdata.paid_amount;
                           currentObj.fdata.paid_amount =  currentObj.formatMoney(currentObj.fdata.paid_amount);
                           currentObj.remaining_amount_money  = currentObj.fdata.remaining_amount;
                           currentObj.fdata.remaining_amount =  currentObj.formatMoney(currentObj.fdata.remaining_amount);

                           /***** */
                           currentObj.fdata.custom_amount = 0;
                           currentObj.custom_amount = 0;
                           currentObj.loan_installments = currentObj.fdata.installments; 


                           if(currentObj.loan_installments.length>0) 
                           {
                               for(let i = 0; i < currentObj.loan_installments.length; i++)
                               {
                                   currentObj.loan_installments[i].amount = currentObj.formatMoneyNew(currentObj.loan_installments[i].amount);
                               }
                           }

                           currentObj.loan_type = currentObj.fdata.loan_type;  
                           // this.custom_tenure_limit = this.fdata.remaining_tenure
                           currentObj.custom_tenure_limit = 300;
                           currentObj.edit_form = 1;
                           currentObj.successmsg = null;
                           currentObj.disableme = true;
                           
                           if(currentObj.fdata_paid_amount == 0)
                           {
                               currentObj.disableme = false;
                           }
                           
                           currentObj.disable_submit =false;
                           currentObj.disable_submit_all =false;
                           currentObj.disable_submit_new =false;
                           currentObj.disable_submit_amount =false;
                           

                           currentObj.change_tenure_trigger = 0,
                           currentObj.change_deduction_trigger = 0,
                           currentObj.pf_loan_form_disable=false;
                           currentObj.pf_contribution = 0,
                           //currentObj.employee_id = currentObj.fdata.employee_id;

                           currentObj.getLastPayrun(currentObj.employee_id);
                           currentObj.getAvailablePf();
                           currentObj.getInstallments();  
                           currentObj.getAvailableMonths(currentObj.fdata.effective_date_of_loan);
                           currentObj.getNextAvailableMonths();

                           currentObj.loan_tenure_new = currentObj.fdata.remaining_tenure;
                           currentObj.deduction_start_month_title = 'Advance Deduction Start Month'; 
                           currentObj.tenure_title = 'Remaining Repayment Tenure'; 

                           var paid_amount = currentObj.toMoney(currentObj.fdata.paid_amount);

                           if(paid_amount > 0 || currentObj.is_custom_payment==1)
                           {
                               currentObj.no_installment = false;
                               currentObj.disableamount = true;
                           }

                           
                           let c = currentObj.fdata.loan_tenure + ' Month(s)';
                           currentObj.loan_tenure_label = c; 
                           

                           //currentObj.showoverlaymodal = false;

                           currentObj.old_repayment_tenure = currentObj.fdata.loan_tenure + currentObj.fdata.interest_tenure;
                           currentObj.old_loan_amount = currentObj.toMoney(currentObj.fdata.loan_amount);

                           if(currentObj.is_custom == 1)
                           {
                             currentObj.manualPaymentList(currentObj.fdata.remaining_tenure,currentObj.fdata.interest_tenure);
                           }

                       }.bind(this)).catch(function (error){alert(error)});
                   
                           
                   })  
                   .catch(function (error) {
                   console.log(error);
                   });
               
           },   
           getApplicationSettings(id)
           {
               if(!this.checkNet()) return false;
               let currentObj = this; 
               
               axios.get(this.$api_url+'/approver/application-data', {
                   params: {
                       module: 7,
                       ref_id: id
                   }
               }).then(function(response){
                   this.approver_settings = response.data;
                   this.loan_approver_app_id = this.approver_settings.application_id;

               }.bind(this)).catch(function (error){currentObj.serverError(error);});

           },
           getBankData()
           {
             this.$bvModal.hide('bv-modal-bank');
             this.editBankInfoNew(this.loan_id);     
             this.editLoanInfo(this.loan_id);
           },
           onSubmit(e) 
           {   
               if(!this.checkNet()) return false;
               
                this.$validator.validateAll().then(result => {
                   if (!result) {
                       return;
                   }
                let current_level = this.approver_settings.application_level +1;
                let depth = this.approver_settings.depth;

                if(current_level == depth && this.loan_approval_status == 1)
                {
                    if(this.bdata.id == undefined)
                    {
                        this.$bvToast.toast('Please provide Bank Information', {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            }); 
                            this.showoverlaymodal = false;
                        return;
                    }

                }
                   
                   e.preventDefault();  
                   let currentObj = this;
                   currentObj.errormsg = '';
                   this.showoverlaymodal = true;
                   let formData = new FormData();
                   this.fdata.installments = [];
                   /***** */
                   var pattern = /^(0|[1-9][0-9]{0,2}(?:(,[0-9]{3})*|[0-9]*))(\.[0-9]+){0,1}$/;
                   //if(pattern.test(this.fdata.loan_amount ))
                   if(1)
                   {
                       this.fdata.loan_amount =  this.toMoney(this.fdata.loan_amount);
                       this.fdata.loan_amount =  Math.round(this.fdata.loan_amount  * 100) / 100;
                   }
                   else
                   {
                       alert("Amount is invalid");
                       return 0;
                   }
                   
                   this.fdata.paid_amount =  this.toMoney(this.fdata.paid_amount);
                   this.fdata.paid_amount =  Math.round(this.fdata.paid_amount  * 100) / 100;
                   this.fdata.remaining_amount =  this.toMoney(this.fdata.remaining_amount);
                   this.fdata.remaining_amount =  Math.round(this.fdata.remaining_amount  * 100) / 100;
                   
                   if(this.fdata.remaining_tenure == this.fdata.loan_tenure)
                   {
                       this.fdata.deduction_start_month = this.fdata.next_installment_month;
                   }
                   

                   if(this.loan_installments.length)
                   { 
                      
                       var installs = 0;
                       for(let i = 0; i<this.loan_installments.length; i++)
                       {
                           installs = this.toMoney(this.loan_installments[i].amount);
                           installs =  Math.round(installs  * 100) / 100;
                           this.loan_installments[i].amount = installs;
                       }
                       this.fdata.installments = JSON.stringify(this.loan_installments);
                       this.fdata.remaining_tenure = this.loan_installments.length;
                   }

                   this.fdata.interest_type = this.pf_settings.pf_loan_installment.opt_value;
                   this.fdata.interest_tenure =  this.pf_settings.pf_extra_installment.opt_value;
                   this.fdata.amount_with_interest =  this.amount_with_interest;

                    if(this.is_status != 0)
                    {
                        this.fdata.status = this.is_status;
                    }
               
                   /**** */
                  

                   if(this.toMoney(this.manual_installment_amount) > 0)
                   {
                      

                      var manual_install_amount = this.toMoney(this.manual_installment_amount);
                      manual_install_amount = Math.round(manual_install_amount  * 100) / 100;
                      this.fdata.paid_amount =  this.fdata.paid_amount + manual_install_amount;
                      this.fdata.paid_amount =  Math.round(this.fdata.paid_amount  * 100) / 100;
                      this.fdata.remaining_amount =  this.fdata.remaining_amount - manual_install_amount;
                      this.fdata.remaining_amount =  Math.round(this.fdata.remaining_amount  * 100) / 100;

                      for(let i = 0; i < this.loan_installment_custom.length; i++)
                       {
                           installs = this.toMoney(this.loan_installment_custom[i].amount);
                           installs =  Math.round(installs  * 100) / 100;
                           this.loan_installment_custom[i].amount = installs;
                       }

                      this.fdata.installments = JSON.stringify(this.loan_installment_custom); 
                      this.fdata.remaining_tenure = this.loan_installment_custom.length;
                      this.fdata.custom_amount = this.toMoney(this.manual_installment_amount);

                      
                   }

                   for (let [key, value] of Object.entries(this.fdata)) 
                   {                    
                       var nm = `${key}`;
                       var fval = `${value}`;
                       formData.append(nm, fval);                    
                   } 
 

                    //    if(this.approver_settings.show == 1)
                    //    {
                       formData.append('approval_status', this.loan_approval_status);  
                       formData.append('approval_comment', this.approval_comment); 
                       

                       for (let [key, value] of Object.entries(this.approver_settings)) 
                       {                    
                           var nm = `${'approval_'+key}`;
                           var fval = `${value}`;
                           formData.append(nm, fval);                    
                       } 

                   
                        if(this.loan_id ==  0)
                        {
                            for (let [key, value] of Object.entries(this.bank_data_new)) 
                        {                    
                            var nm = `${'bank_'+key}`;
                            var fval = `${value}`;
                            formData.append(nm, fval);                    
                        }  

                        if(this.upload_file.length > 0)
                        {
                                this.upload_file.forEach(file => {
                                    formData.append("upload_file[]", file)
                                })
                        }

                        }
                    
                    //formData.append('approver_settings', this.approver_settings); 
                    //    } 
                    formData.append('disbursement_date', this.fdata.effective_date_of_loan);  
                  
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                   this.showoverlay = true;
                   axios.post(this.$api_url+'/pf/loan/save', formData,config)
                    .then(function (response) 
                    {
                        
                        //this.$bvToast.toast("Saved!", {
                          //      title: `Success`,
                            //    variant: 'success',
                              //  solid: true
                            //});
                        var data = this.fdata.employee_id;
                        //this.$emit('childToParent'); 
                        
                        if(response.data.success == false) {
                            this.$emit('childToParent', response.data); 
                        } else {
                                this.$bvToast.toast("Saved!", {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });
                            this.$emit('childToParent');
                        }
                        //this.resetForm();
                        this.showoverlay = false;
                        this.showoverlaymodal = false;
                        
                    }.bind(this))
                    .catch(function (error) 
                    {           
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;                                    
                        for (var data in currentObj.errormsg)
                        {
                            var msg = currentObj.errormsg[data];
                            currentObj.$bvToast.toast(msg, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            }); 
                            currentObj.$validator.reset(); 
                        } 
                    });
               });
           },
           getBankList: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/banklist/' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.bank_names = response.data;
                }.bind(this)).catch(function (error){this.serverError(error);});

            },
            changeDateAndTenure()
            {
                this.getInstallments();
            },
       }, 
       computed:
       {
           checkPFLimit()
           {
               


               let loan_mon = this.toMoney(this.fdata.loan_amount);

               

               if(loan_mon > this.pf_contribution)
               {
                   this.pf_loan_form_disable =true;
                   this.loan_amount_disable_text = 'The Advance Amount must be less or equal to the total provident fund balance';
                   if(this.edit_form==1 && this.fdata.status != 1)
                   {
                       this.pf_loan_form_disable =false;
                   }
               }
               else
               {
                   this.pf_loan_form_disable =false;

                   if(loan_mon % 1 != 0)
                    {
                            
                            this.pf_loan_form_disable =true;
                            this.loan_amount_disable_text = 'The Advance Amount cannot have decimal places';
                    }
                    else
                    {
                            this.loan_amount_disable_text = '';
                            this.pf_loan_form_disable =false;
                    }
               }

              
           },
           checkInstallmentamount() 
           {

               
               var ct_amount = 0.00; 
           
               if(this.fdata.loan_tenure > 0 && (this.fdata.deduction_start_month != null && this.fdata.deduction_start_month != '') && this.fdata.loan_amount != '' && this.fdata.effective_date_of_loan != '' && (ct_amount >= 0))
               {
                   this.getInstallments();
               }  
               else 
               { 
                
                   this.showInstallment = false; 
                   this.loan_installments = [];
               }

           },
           onInstallmentChange()
           {
               this.show_extra_installment_info = false;
               
               console.log('loan_installments onInstallmentChange  '+ this.loan_installments.length);

               if(this.loan_installments.length>0)
               { 
                   
                   var installment_total = 0;
                   var install_money = 0;
                   var interest_tenure = 0;
                   var reguler_tenure = this.loan_installments.length - interest_tenure;
                   var number = 0;
                   for(let i = 0; i< this.loan_installments.length; i++)
                   {
                       
                       install_money = this.toMoney(this.loan_installments[i].amount);
                       number = Math.round(install_money * 100) / 100;

                       console.log(i); 
                       console.log(number);
                       installment_total  = installment_total + number;
                   }
                   installment_total = Math.round(installment_total * 100) / 100;
                   var payable_amount = 0;


                   var pf_loan_installment_type = this.pf_settings.pf_loan_installment.opt_value;
                   var pf_extra_installment = this.pf_settings.pf_extra_installment.opt_value;
                   
                   if(pf_loan_installment_type != 'plus_one' && pf_loan_installment_type != 'plus_one_fixed' && pf_loan_installment_type != 'govt_interest' && pf_loan_installment_type != 'fixed_interest')
                   {
                       if(this.edit_form) 
                       {
                           if(this.disableamount == false)
                           { 
                               
                               payable_amount = this.toMoney(this.fdata.loan_amount);
                               payable_amount = Math.round(payable_amount * 100) / 100;
                           }
                           else
                           {
                               payable_amount = this.toMoney(this.fdata.remaining_amount);
                               payable_amount = Math.round(payable_amount * 100) / 100;
                           }
                           
                       }
                      
                       if(!this.edit_form)
                       {
                           payable_amount = this.toMoney(this.fdata.loan_amount);
                           payable_amount = Math.round(payable_amount * 100) / 100;
                       }
                       
                      
                   }
                   else
                   {

                    if(1)
                    {
                        var pf_extra_installment = this.pf_settings.pf_extra_installment.opt_value;
                        let fractioned_payable_amount = 0;
                        
                        if(pf_loan_installment_type == 'plus_one')
                        {


                                var loan_amount = this.toMoney(this.fdata.loan_amount);
                                loan_amount = Math.round( loan_amount * 100) / 100;
                                var interest_tenure = parseInt(pf_extra_installment);

                                if(this.fdata.status == 2)
                                {
                                    var reguler_tenure = this.fdata.loan_tenure;
                                }
                                else
                                {
                                    var reguler_tenure = this.loan_installments.length - interest_tenure;
                                }
                                
                                var frac_month_amount =  loan_amount/reguler_tenure;
                                frac_month_amount = Math.round(frac_month_amount);
                                var extra_amount = frac_month_amount * interest_tenure;

                                let rounded_frac_month_amount = Math.round(frac_month_amount);
                                let total_installment_number  = reguler_tenure + interest_tenure;
                                let rounded_payable_amount = rounded_frac_month_amount * total_installment_number;
                                fractioned_payable_amount = rounded_payable_amount - loan_amount - frac_month_amount; 


                                loan_amount = rounded_payable_amount - fractioned_payable_amount - extra_amount;


                                
                              
                            
                        }
                        else if(pf_loan_installment_type == 'plus_one_fixed')
                        {
                            var loan_amount = this.toMoney(this.fdata.loan_amount);
                            loan_amount = Math.round( loan_amount * 100) / 100;
                            var pf_interest_rate = parseFloat(this.pf_settings.pf_interest_rate.opt_value);
                            var extra_amount = (loan_amount/100)*pf_interest_rate;
                            extra_amount = Math.trunc(extra_amount*100)/100;

                            var interest_tenure = parseInt(pf_extra_installment);
                            var reguler_tenure = this.loan_installments.length - interest_tenure;
                            console.log('interest_tenure');
                            console.log(interest_tenure);
                            console.log('reguler_tenure');
                            console.log(reguler_tenure);
                            console.log('loan_amount');
                            console.log(loan_amount);
                            console.log('extra_amount');
                            console.log(extra_amount);
                        
                        }
                        else if(pf_loan_installment_type == 'govt_interest')
                        {
                            var loan_amount = this.toMoney(this.fdata.loan_amount);
                            loan_amount = Math.round( loan_amount * 100) / 100;
                            var pf_interest_rate = parseFloat(this.pf_settings.pf_interest_rate.opt_value);
                            var extra_amount = (loan_amount/100)*pf_interest_rate;
                            
                            if(this.loan_installments.length >13)
                            {
                                var interest_tenure = 2;
                            }
                            else
                            {
                                var interest_tenure = 1;
                            }
                            extra_amount = extra_amount*interest_tenure;
                            
                            var reguler_tenure = this.loan_installments.length - interest_tenure;
                            
                            
                        }
                        else if(pf_loan_installment_type == 'fixed_interest')
                        {

                            var loan_amount = this.toMoney(this.fdata.loan_amount);
                            loan_amount = Math.round( loan_amount * 100) / 100;
                            var pf_interest_rate = parseFloat(this.pf_settings.pf_interest_rate.opt_value);
                            var govt_interest_amount = (loan_amount/100)*pf_interest_rate;
                            var interest_tenure = 0;
                            var total_interest = (govt_interest_amount/12)*this.loan_installments.length;
                            var extra_amount = total_interest;
                            
                            
                        }


                        this.show_extra_installment_info = true;
                        this.amount_with_interest =  loan_amount + extra_amount;
                        this.extra_amount = extra_amount;

                        if(fractioned_payable_amount > 0)
                        {
                                this.extra_amount = extra_amount - 1;
                        }

                        this.pf_settings.pf_extra_installment.opt_value =interest_tenure;
                        if(this.edit_form)
                        {
                            if(this.disableamount == false)
                            {
                                
                                payable_amount = this.amount_with_interest;
                                payable_amount = Math.round(payable_amount * 100) / 100;

                              
                            }
                            else
                            {
                                //payable_amount = this.toMoney(this.fdata.remaining_amount);
                                payable_amount = this.amount_with_interest;
                                payable_amount = Math.round(payable_amount * 100) / 100;
                               
                               
                            }
                            
                        }
                        
                        if(!this.edit_form)
                        {
                            payable_amount = this.toMoney(this.fdata.loan_amount) + extra_amount;
                            payable_amount = Math.round(payable_amount * 100) / 100;

                            console.log('extra_amount');
                            console.log(extra_amount);
                            console.log('payable_amount');
                            console.log(payable_amount);
                        }
                    }
                       

                   } 
                   console.log('installment_total');
                   console.log(installment_total);
                   console.log('payable_amount');
                   console.log(payable_amount);

                   if(installment_total != payable_amount)
                   { 
                       var differ = Math.abs(installment_total - payable_amount)
                       
                       if(differ > 0.5)
                       {
                           this.disable_submit = true;
                           this.remaining_installment_amount = payable_amount -installment_total;
                           if (isNaN(this.remaining_installment_amount)) 
                           {
                           this.remaining_installment_amount =' *Installment amount must be equal to total payable. Installment field contain invalid value';
                           }
                           else
                           {
                               if(this.remaining_installment_amount> 0)
                               {
                                   this.remaining_installment_amount  = this.formatMoney(this.remaining_installment_amount);
                                   this.remaining_installment_amount =' *Installment amount must be equal to total payable. Total Installment amount is '+this.remaining_installment_amount+' less than total payable';
                               }
                               if(this.remaining_installment_amount< 0)
                               {
                                   this.remaining_installment_amount = this.remaining_installment_amount * (-1);
                                   this.remaining_installment_amount  = this.formatMoney(this.remaining_installment_amount);
                                   this.remaining_installment_amount =' *Installment amount must be equal to total payable. Total Installment amount is '+this.remaining_installment_amount+' more than total payable';
                               }
                           }
                       }
                       else
                       {
                           this.disable_submit = false;
                           this.remaining_installment_amount =this.formatMoney(0);
                       }

                   } 
                   else
                   {
                       this.disable_submit = false;
                       this.remaining_installment_amount =this.formatMoney(0);
                   }
               } 

               console.log('loan_installments onInstallmentChange 2 '+ this.loan_installments.length);
           },
           checkInput()
           {
               if(this.disable_submit_new || this.disable_submit || this.disable_submit_amount || this.pf_loan_form_disable)
               {
                   this.disable_submit_all = true;
               }
               else
               {
                   this.disable_submit_all = false;
               }
               
           },
           checkName()
           {
                if(this.employee_name != '')
                {
                    this.bank_data_new.beneficiary_name = this.employee_name;
                }
                else
                {
                    
                }
           },
           
       },
       created: function()
       {

           this.pf_contribution = 0;
           this.loan_installments = [];
           this.loan_type = 1;
           
          
           
           this.getPFLoanTerms();
           if(this.loan_id > 0)
           {
               this.thread_key += 1;
               this.getApplicationSettings(this.loan_id);
               this.getLastPayrun(this.employee_id);
               this.editLoanInfo(this.loan_id);
               this.editBankInfoNew(this.loan_id);
           }
           else
           {  
               this.getBankList();
               this.getAvailablePf();
               this.getPFSettings(); 
               this.getLastPayrun(this.employee_id);
               this.addNewLoan(1);
               
           }  
           if(this.atl_company_package_title == 'Provident Fund Only')
           {
               this.fdata.is_appear_in_payslip = 1;
           }

       }    
   }
</script>
<style>
.loan-card-title {
   /* text-align: center; */
   padding-bottom: 10px;
   font-size: 16px;
   /* color: #00c5fb !important; */
}

.loan_card_wrapper {
   padding-top: 12px;
   padding-bottom: 12px;
}
.pf_loan_form_front .b-overlay
{
	height: 100%;  
}
.loan_form_bank_details .col-form-label {
	color: #3A52A6;
}

.ess-portal .ibox-content .custom-file-label span {
	font-size: 12px;
	color: #3A52A6;
	font-weight: unset;
}

.shortcut-button {
	height: 90px;
	padding: 15px;
    text-align: center;
}

</style>
